export function useSeoImageURL(featuredImageRendered: string | null | undefined, { width, height }: { width: number, height: number }) {
  const { public: { twicpics: { domain } } } = useRuntimeConfig()

  const imagePath = `${domain}${featuredImageRendered ? useTwicPicsBlogUrl(featuredImageRendered) : '/library/media/pictures/frontend/sharing-preview.png'}`

  return `${imagePath}?twic=v1/focus=auto/cover=${width}x${height}`
}
